import axios from '@util/axios';
import appConfig from "@/appConfig";
import requestManager from "@/components/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    upload_image() {
        return {
            url: appConfig.apiBaseUrl + 'base/upload/upload_image',
            // method : 'post',     // default: post
            name : 'upfile',       // default: file
            // data : {}            // extra form data
        }
    },

    config: {
        uploadImage: {
            url: 'base/upload/upload_image',
            // method : 'post',     // default: post
            name : 'upfile',       // default: file
            // data : {}            // extra form data
        },
        uploadVideo: {
            url: 'upload/oss/video',
            // method : 'post',     // default: post
            // name : 'file',       // default: file
            // data : {}            // extra form data
        },
        uploadVoice: {
            url: 'upload/oss/voice',
            // method : 'post',     // default: post
            // name : 'file',       // default: file
            // data : {}            // extra form data
        },
        uploadFile: {
            url: 'upload/oss/file',
            // method : 'post',     // default: post
            // name : 'file',       // default: file
            // data : {}            // extra form data
        }
    },

    /**
     * @param   {{Object}}      file    File object
     */
    uploadImage: function (file) {
        let config = this.config.uploadImage;
        let url = config.url;
        let method = config.method || 'post';
        let name = config.name || 'file';
        let data = config.data || {};

        // build form data
        let formData = this.buildFormData({
            data: data,
            name: name,
            file: file
        });

        return this.sendRequest({
            url: url,
            method: method,
            data: formData
        });
    },

    uploadImage2(file, callback) {

        let config = this.config.uploadImage;
        let url = config.url;
        let method = config.method || 'post';
        let name = config.name || 'file';
        let data = config.data || {};

        requestManager.uploadFile({
            url : url,
            method : method,
            name : name,
            data : data,
        }, file, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (typeof(result) === 'string')
            {
                try {
                    result = JSON.parse(result);
                }
                catch (e)
                {
                    return;
                }
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            let data = result.data;

            callback(data);
        });
    },

    /**
     * @param   {{Object}}      file    File object
     */
    uploadVideo: function (file) {
        let config = this.config.uploadVideo;
        let url = config.url;
        let method = config.method || 'post';
        let name = config.name || 'file';
        let data = config.data || {};

        // build form data
        let formData = this.buildFormData({
            data: data,
            name: name,
            file: file
        });

        return this.sendRequest({
            url: url,
            method: method,
            data: formData
        });
    },

    /**
     * @param   {{Object}}      file    File object
     */
    uploadVoice: function (file) {
        let config = this.config.uploadVoice;
        let url = config.url;
        let method = config.method || 'post';
        let name = config.name || 'file';
        let data = config.data || {};

        // build form data
        let formData = this.buildFormData({
            data: data,
            name: name,
            file: file
        });

        return this.sendRequest({
            url: url,
            method: method,
            data: formData
        });
    },

    /**
     * @param   {{Object}}      file    File object
     */
    uploadFile: function (file) {
        let config = this.config.uploadFile;
        let url = config.url;
        let method = config.method || 'post';
        let name = config.name || 'file';
        let data = config.data || {};

        // build form data
        let formData = this.buildFormData({
            data: data,
            name: name,
            file: file
        });

        return this.sendRequest({
            url: url,
            method: method,
            data: formData
        });
    },

    /**
     * @param   {{Object}}      options
     */
    buildFormData: function (options = {}) {

        let data = options.data || {};
        let name = options.name;
        let file = options.file;

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        formData.append(name, file);
        return formData;
    },

    /**
     * @param   {{Object}}      options
     */
    sendRequest: function (options) {
        let request = axios.create({
            headers: {
                'Content-Type': 'multipart/form-data;'
            },
            withCredentials: true
        });
        return request(options);
    }

};
